'use client';

import styled from 'styled-components';
import { Swiper } from 'swiper/react';

import { SkeletonAnimation } from '@/styles/animation';

const Container = styled.section`
  background-color: #f2f2f2;
  width: 100%;
  aspect-ratio: 1/1;
`;

const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  cursor: pointer;
`;

const CustomSwiper = styled(Swiper)`
  position: relative;
  width: 100%;
`;

const CustomPagination = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 20px;
  bottom: 20px;
  width: 52px;
  padding: 6px 0px;
  border-radius: 100px;
  background-color: #111;
  z-index: 1;

  /* pagination 공통 스타일 */
  .swiper-pagination-current,
  .swiper-pagination-separator,
  .swiper-pagination-total {
    font-size: 14px;
    font-weight: 600;
    line-height: 17px;
  }

  /* 현재 번호 style */
  .swiper-pagination-current {
    color: ${({ theme }) => theme.rootColor.white};
  }

  /* 구분자, 전체 번호 style */
  .swiper-pagination-separator,
  .swiper-pagination-total {
    color: #a1a1a1;
  }
`;

// Skeleton UI
const Skeleton = styled.div`
  ${SkeletonAnimation};
  width: 100%;
  height: 100%;
`;

const BannerStyled = {
  Container,
  ImageWrapper,
  CustomSwiper,
  CustomPagination,
  Skeleton,
};

export default BannerStyled;
